import { API_KEY, API_URL, API_URL_WITHOUT_USER } from "../../Utils/API";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import ROUTES from "../../Utils/routesConstants";
import {
  getToken,
  GET_PROFILE_DETAILS,
  getTempararyTokenProviderAssist,
  getCampaignsToken,
} from "../../Utils/types";

export const getProfileDetails = () => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
  ? `${API_URL_WITHOUT_USER}/Campaigns/GetProfileDetails/${getCampaignsToken()}`
  : `${API_URL}/GetProfileDetails`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
        ? getTempararyTokenProviderAssist() : window.location.pathname.includes("campaigns") ? null
        : getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PROFILE_DETAILS, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_PROFILE_DETAILS, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const updateProfileDetailsAction = (data) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
  ? `${API_URL_WITHOUT_USER}/Campaigns/UpdateProfileDetails/${getCampaignsToken()}`
  : `${API_URL}/UpdateProfileDetails`;
  return HttpUtil.makePOST(url, data, {
    Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST) 
      ? getTempararyTokenProviderAssist() : window.location.pathname.includes("campaigns") ? null
      : getToken(),
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("success", "Details updated successfully", dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const addBranchAction = (data) => (dispatch) => {
  const url = `${API_URL}/AddBranches`;
  return HttpUtil.makePOST(url, data, {
    Authorization: getToken(),
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      getSnackbarSuccess("success", res?.data?.message, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const updateBranchAction = (data) => (dispatch) => {
  const url = `${API_URL}/UpdateBranchDetails`;
  return HttpUtil.makePOST(url, data, {
    Authorization: getToken(),
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      getSnackbarSuccess("success", res?.data?.message, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const deleteBranchAction = (id) => (dispatch) => {
  const url = `${API_URL}/DeleteBranches?ProviderId=${id}`;
  return HttpUtil.makePOST(
    url,
    {},
    {
      Authorization: getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getSnackbarSuccess("success", res?.data?.message, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};
